document.addEventListener('DOMContentLoaded', function() {
  
    const tabSections = document.querySelectorAll('.custom-tabbed-products-section');
  
    tabSections.forEach(function(container) {
      const triggers = container.querySelectorAll('.js-tab-trigger');
      const contents = container.querySelectorAll('.js-tab-content');
  
      triggers.forEach(trigger => {
        trigger.addEventListener('click', function() {
          const targetId = this.getAttribute('data-target');
          
          triggers.forEach(t => t.classList.remove('active'));
          contents.forEach(c => {
            c.style.display = 'none';
            c.classList.remove('active');
          });
          
          this.classList.add('active');
          const targetContent = document.getElementById(targetId);
          
          if(targetContent) {
            targetContent.style.display = 'block';
            targetContent.classList.add('active');
            
            const sliders = targetContent.querySelectorAll('.custom-flickity-slider');
            sliders.forEach(slider => {
              if (window.Flickity) {
                const flkty = Flickity.data(slider);
                if (flkty) {
                  flkty.resize(); 
                }
              }
            });
            
            window.dispatchEvent(new Event('resize'));
          }
        });
      });
    });
  
  });

  document.addEventListener('DOMContentLoaded', function() {
  
    const tabSections = document.querySelectorAll('.custom-text-tabs-section');
  
    tabSections.forEach(function(container) {
      const triggers = container.querySelectorAll('.js-tab-trigger');
      const contents = container.querySelectorAll('.js-tab-content');
  
      triggers.forEach(trigger => {
        trigger.addEventListener('click', function() {
          const targetId = this.getAttribute('data-target');
          
          triggers.forEach(t => t.classList.remove('active'));
          contents.forEach(c => {
            c.style.display = 'none';
            c.classList.remove('active');
          });
          
          this.classList.add('active');
          const targetContent = document.getElementById(targetId);
          
          if(targetContent) {
            targetContent.style.display = 'block';
            targetContent.classList.add('active');
            
            const sliders = targetContent.querySelectorAll('.custom-flickity-slider');
            sliders.forEach(slider => {
              if (window.Flickity) {
                const flkty = Flickity.data(slider);
                if (flkty) {
                  flkty.resize(); 
                }
              }
            });
            
            window.dispatchEvent(new Event('resize'));
          }
        });
      });
  
      const sectionId = container.id.replace('TextTabsSlider-', '');
      const recentTabBtn = document.getElementById(`tab-btn-recent-${sectionId}`);
      const recentWrapper = document.getElementById(`recently-viewed-wrapper-${sectionId}`);
      
      if (recentTabBtn && recentWrapper) {
        const observer = new MutationObserver(function(mutations) {
          if (recentWrapper.querySelectorAll('.grid-item, .product-card, .grid-product').length > 0) {
            recentTabBtn.style.display = 'block';
            observer.disconnect();
          }
        });
  
        observer.observe(recentWrapper, { childList: true, subtree: true });
  
        setTimeout(() => {
          if (recentWrapper.querySelectorAll('.grid-item, .product-card, .grid-product').length > 0) {
            recentTabBtn.style.display = 'block';
          }
        }, 1500);
      }
    });
  
  });

  document.addEventListener('DOMContentLoaded', function() {
  
    if (Shopify.designMode) {
      document.addEventListener('shopify:section:load', function(event) {
        if (event.target.querySelector('.complete-look-products')) {
          const sliders = event.target.querySelectorAll('.custom-flickity-slider');
          sliders.forEach(slider => {
            if (window.Flickity) {
              new Flickity(slider);
            }
          });
        }
      });
    }
  
  });
  
  (function() {
    if (!window.location.pathname.includes('/products/')) return;

    function buildPdpTabs() {
      const recommendations = document.querySelector('product-recommendations, .product-recommendations, [data-section-id*="recommendations"]');
      const recentlyViewed = document.querySelector('recently-viewed, .recently-viewed-products, [data-section-id*="recently-viewed"]');

      if (!recommendations || !recentlyViewed) return false;

      if (document.body.classList.contains('pdp-tabs-ready')) return true;

      const recSection = recommendations.closest('.shopify-section') || recommendations;
      const viewSection = recentlyViewed.closest('.shopify-section') || recentlyViewed;

      const recHeader = recSection.querySelector('.section-header, header');
      if (recHeader) recHeader.style.display = 'none';
      
      const viewHeader = viewSection.querySelector('.section-header, header');
      if (viewHeader) viewHeader.style.display = 'none';

      document.body.classList.add('pdp-tabs-ready');

      const tabContainer = document.createElement('div');
      tabContainer.className = 'pdp-tab-container';
      tabContainer.innerHTML = `
        <div class="pdp-tab-buttons">
          <button class="pdp-tab-btn active" data-target="recommendations">İlgilenebileceğiniz Ürünler</button>
          <button class="pdp-tab-btn" data-target="viewed">Son Gezdikleriniz</button>
        </div>
      `;

      recSection.parentNode.insertBefore(tabContainer, recSection);
      
      viewSection.style.display = 'none';

      const btns = tabContainer.querySelectorAll('.pdp-tab-btn');
      btns.forEach(btn => {
        btn.addEventListener('click', function(e) {
          e.preventDefault();
          btns.forEach(b => b.classList.remove('active'));
          this.classList.add('active');

          if (this.dataset.target === 'recommendations') {
            recSection.style.display = 'block';
            viewSection.style.display = 'none';
          } else {
            recSection.style.display = 'none';
            viewSection.style.display = 'block';
            setTimeout(function() {
              window.dispatchEvent(new CustomEvent('scrollable-dots-init'));
            }, 150);
          }
          window.dispatchEvent(new Event('resize'));
        });
      });

      return true;
    }

    if (!buildPdpTabs()) {
      const observer = new MutationObserver((mutations, obs) => {
        if (buildPdpTabs()) {
          obs.disconnect();
        }
      });
      
      observer.observe(document.body, { childList: true, subtree: true });
      
      setTimeout(() => observer.disconnect(), 10000);
    }
  })();


  
  document.addEventListener("DOMContentLoaded", function() {
    
    const sozluk = {
      "Search": "Mağaza Ara...",
      "Directions": "Yol Tarifi",
      "Phone": "Telefon",
      "Get Directions": "Yol Tarifi Al",
      "No results found": "Sonuç bulunamadı",
      "Distance": "Mesafe"
    };

    const observer = new MutationObserver(function(mutations) {
      document.querySelectorAll('input').forEach(input => {
        if (sozluk[input.placeholder]) {
          input.placeholder = sozluk[input.placeholder];
        }
      });

      const walker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT, null, false);
      let node;
      while (node = walker.nextNode()) {
        let text = node.nodeValue.trim();
        if (sozluk[text]) {
          node.nodeValue = node.nodeValue.replace(text, sozluk[text]);
        }
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });

    setTimeout(() => observer.disconnect(), 8000);
  });


  if (!customElements.get('buy-buttons-consent')) {
    customElements.define('buy-buttons-consent', class BuyButtonsConsent extends HTMLElement {
      constructor() {
        super();
        this.masterCb = null;
        this.warningMsg = null;
        this.checkoutWrapper = null;
        this.kvkkCb = null;
        this.acikCb = null;
      }

      connectedCallback() {
        const root = this.closest('block-buy-buttons');
        this.kvkkCb = this.querySelector('[data-kvkk-consent]') || root?.querySelector('[data-kvkk-consent]');
        this.acikCb = this.querySelector('[data-acik-riza-consent]') || root?.querySelector('[data-acik-riza-consent]');
        this.masterCb = this.querySelector('[data-master-consent]');
        this.warningMsg = this.querySelector('[data-kvkk-warning]');
        this.checkoutWrapper = this.closest('.buy-buttons-container')?.querySelector('[data-dynamic-checkout-wrapper]');

        this._setupListeners();
      }
  
      _setupListeners() {
        if (this.kvkkCb) this.kvkkCb.addEventListener('change', () => this.updateStatus());
        if (this.acikCb) this.acikCb.addEventListener('change', () => this.updateStatus());

        if (this.checkoutWrapper) {
          this.checkoutWrapper.addEventListener('click', (e) => {
            if (this.checkoutWrapper.classList.contains('buy-buttons__dynamic-checkout-wrapper--disabled')) {
              if (this.warningMsg) this.warningMsg.style.display = 'block';
            }
          });
        }

        this.updateStatus();
      }
  
      updateStatus() {
        const isKvkkChecked = this.kvkkCb?.checked;
        
        if (this.masterCb) {
          this.masterCb.checked = isKvkkChecked;
          this.masterCb.dispatchEvent(new Event('change', { bubbles: true }));
        }
  
        if (isKvkkChecked) {
          if (this.warningMsg) this.warningMsg.style.display = 'none';
          this.checkoutWrapper?.classList.remove('buy-buttons__dynamic-checkout-wrapper--disabled');
        } else {
          this.checkoutWrapper?.classList.add('buy-buttons__dynamic-checkout-wrapper--disabled');
        }
      }
    });
  }

  class VariantSyncer extends HTMLElement {
    constructor() {
      super();
      this.selectors = [
        '.variant-button-wrap--color',
        '.product-stock-status',
        '.element-radio'
      ];
      this.boundHandleVariantChange = this.handleVariantChange.bind(this);
    }

    connectedCallback() {
      if (!this.dataset.sectionId || !this.dataset.productId) return;
      this.eventName = 'variant:change:' + this.dataset.sectionId + ':' + this.dataset.productId;
      document.addEventListener(this.eventName, this.boundHandleVariantChange);
    }

    disconnectedCallback() {
      if (this.eventName) {
        document.removeEventListener(this.eventName, this.boundHandleVariantChange);
      }
    }

    handleVariantChange(e) {
      const { html, loading } = e.detail || {};
      if (loading || !html) return;
      this.updateFromDocument(html);
    }

    updateFromDocument(doc) {
      if (!doc || !doc.querySelector) return;
      const ourPicker = this.closest('block-variant-picker');
      const sourcePicker = doc.querySelector(
        `block-variant-picker[data-section-id="${this.dataset.sectionId}"][data-product-id="${this.dataset.productId}"]`
      );
      if (!ourPicker || !sourcePicker) return;
      this.selectors.forEach(selector => {
        const newElements = sourcePicker.querySelectorAll(selector);
        const currentElements = ourPicker.querySelectorAll(selector);
        currentElements.forEach((el, index) => {
          const source = newElements[index] || newElements[0];
          if (source && el !== source && el.innerHTML !== source.innerHTML) {
            el.innerHTML = source.innerHTML;
          }
        });
      });
    }
  }
  
  // Custom elementi tarayıcıya kaydet
  if (!customElements.get('variant-syncer')) {
    customElements.define('variant-syncer', VariantSyncer);
  }